module.exports = __webpack_public_path__ + "img/IMG_0459_L_BlackMatted.a519524a.jpg";